import React, { useCallback } from 'react';
import { Dialog } from '../../../../../Dialog/Dialog';
import { Button } from '../../../../../Button/Button';
import {
  OnQuickReportsChanged,
  QueryModel,
  SortModel
} from '../../../../utils/DataTableQueryProvider/DataTableQuery.types';
import { Typography } from '../../../../../Typography/Typography';
import { useIntlUds } from '../../../../../../translations/UdsIntlProvider';

interface Props<Q extends QueryModel, S extends SortModel> {
  report: OnQuickReportsChanged<Q, S> | undefined;
  onClose: () => void;
  onSaveClose: () => void;
  onSave: (quickReport: OnQuickReportsChanged<Q, S>) => Promise<boolean>;
}
export const ScheduleDeleteExportDialog = <Q extends QueryModel, S extends SortModel>({
  report,
  onClose,
  onSaveClose,
  onSave
}: Props<Q, S>) => {
  const { intl } = useIntlUds();

  const handleOnSave = useCallback(async () => {
    if (!report) return;
    const response = await onSave(report);
    if (response) {
      onSaveClose();
    }
  }, [onSaveClose, onSave, report]);

  return (
    <Dialog
      dataTest="delete-scheduled-export-dialog"
      title={intl.DataTable.ScheduleExport.DeleteDialog.title}
      subTitle={intl.DataTable.ScheduleExport.DeleteDialog.message}
      open={!!report}
      onClose={onClose}
      showCancelButton
      actions={[
        <Button
          key="schedule-delete-export-submit-button"
          dataTest="remove-submit"
          variant="contained"
          color="primary"
          error
          onClick={handleOnSave}
        >
          {intl.DataTable.ScheduleExport.DeleteDialog.btn}
        </Button>
      ]}
    >
      <Typography variant="body1Bold">{report?.name}</Typography>
    </Dialog>
  );
};
